module.exports = __webpack_public_path__ + "static/img/chanpintu@2x.da57f14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpintu@2x.png
// module id = 6Wc6
// module chunks = 26